import {
  Control,
  FieldArrayPath,
  FieldValues,
  useFieldArray,
} from 'react-hook-form';

import { Grid, IconButton, Stack } from '@mui/material';

import { IcDeleteTrash } from '@/assets/images';
import { RenderFormField } from '@/components';
import { Button } from '@/components/TailwindComponents';
import { colors } from '@/theme/variables';

import { PhoneNumbersFormFields } from './data';

interface IPhoneNumbersFormProps<
  TFieldValues extends FieldValues = FieldValues,
> {
  name: FieldArrayPath<TFieldValues>;
  control: Control<TFieldValues, any>;
  nestIndex?: number;
}
export const PhoneNumbersForm = <
  TFieldValues extends FieldValues = FieldValues,
>({
  name,
  control,
}: IPhoneNumbersFormProps<TFieldValues>) => {
  const { remove, append, fields } = useFieldArray({
    control,
    name,
  });

  const handleAddPhoneNumber = () => {
    const newPhoneNumber = {
      phoneNumberExt: '',
      phoneNumber: '',
    };
    append(newPhoneNumber as any);
  };

  return (
    <Stack my={2}>
      {fields.map((phoneField, index: number) => (
        <Grid container columnSpacing={2} key={`row-${phoneField.id}`}>
          {PhoneNumbersFormFields.map(({ grid, ...field }) => (
            <Grid key={`${field.name}-${phoneField.id}`} xs={3} item {...grid}>
              <RenderFormField
                {...field}
                name={`${name}.${index}.${field.name}`}
              />
            </Grid>
          ))}
          <Grid mt={1} xs={3} item>
            <IconButton
              onClick={() => remove(index)}
              sx={{ color: colors.error.main, mt: 2, alignSelf: 'center' }}
            >
              <IcDeleteTrash />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button
        color="error"
        type="button"
        size="sm"
        variant="secondary"
        className="w-fit text-sm"
        onClick={handleAddPhoneNumber}
      >
        + Add phone number
      </Button>
    </Stack>
  );
};
